(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initHeroImageScroll(root) {
    const scope = root || document;
    const sliders = scope.querySelectorAll('.hero__media-grid--scroll[data-auto-scroll="true"]');

    sliders.forEach((slider) => {
      if (slider.dataset.autoScrollInitialized === 'true') return;
      slider.dataset.autoScrollInitialized = 'true';

      let index = 0;

      setInterval(() => {
        const slides = Array.from(slider.children).filter((slide) => {
          const isMediaSlide = slide.matches('.hero__media-wrapper, picture.hero__media, svg.hero__media');
          const isVisible = window.getComputedStyle(slide).display !== 'none';
          return isMediaSlide && isVisible;
        });

        if (slides.length <= 1) return;

        index = (index + 1) % slides.length;

        slider.scrollTo({
          left: slides[index].offsetLeft - slider.offsetLeft,
          behavior: 'smooth'
        });
      }, 4000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroImageScroll(document));
  } else {
    initHeroImageScroll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeroImageScroll(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
